import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from "@mui/material";
import PaymentEditDialog from "pages/payments/menu/PaymentEditDialog";
import React from "react";
import { useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useDispatch, useSelector } from "react-redux";
import {
  deletePaymentTypeThunk,
  getPaymentTypesThunk,
  paymentTypeSelector,
} from "store/reducers/payment/paymentSlice";

const PaymentList = () => {
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  useEffect(() => {
    dispatch(getPaymentTypesThunk());
  }, []);
  const paymentTypes = useSelector(paymentTypeSelector.selectAll);
  const removePaymentType = (id) => {
    dispatch(deletePaymentTypeThunk(id));
  };
  const { status } = useSelector((state) => state.paymentType);
  const [currentItem, setCurrentItem] = React.useState(null);
  const [openPaymentTypeUpdate, setOpenPaymentTypeUpdate] =
    React.useState(false);
  const handlePaymentTypeClose = () => {
    setOpenPaymentTypeUpdate(false);
  };
  const handleEditClick = (item) => {
    setCurrentItem(item);
    setOpenPaymentTypeUpdate(true);
  };
  return (
    <Box>
      <Box
        component={Typography}
        variant="h4"
        sx={{ textDecoration: "underline", color: "text.secondary", mb: 1 }}
      >
        Payment Types
      </Box>
      <Grid container>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Box
            sx={{ backgroundColor: "#e7ebf0", borderRadius: 2, flex: 1 }}
            padding={1}
          >
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ minWidth: 150 }}>
                      {isSmallScreen ? "Name" : "Payment name"}
                    </TableCell>
                    <TableCell align="center" sx={{ minWidth: 120 }}>
                      {isSmallScreen ? "Desc" : "Payment description"}
                    </TableCell>
                    <TableCell align="center">
                      {isSmallScreen ? "Logic" : "Logic code"}
                    </TableCell>
                    <TableCell align="center" sx={{ minWidth: 100 }}>
                      Image
                    </TableCell>
                    <TableCell>&nbsp;</TableCell>
                    <TableCell>&nbsp;</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paymentTypes.map((paymentType) => (
                    <TableRow
                      key={paymentType.id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {paymentType.name}
                      </TableCell>
                      <TableCell align="center">{paymentType.desc}</TableCell>
                      <TableCell align="center">{paymentType.code}</TableCell>
                      <TableCell align="center">
                        {paymentType.image ? (
                          <LazyLoadImage
                            width={100}
                            height={100}
                            src={paymentType.image}
                            style={{ objectFit: "contain" }}
                          />
                        ) : (
                          <Typography color="text.secondary"> None </Typography>
                        )}
                      </TableCell>
                      <TableCell align="center">
                        <Button
                          variant="outlined"
                          onClick={() => handleEditClick(paymentType)}
                        >
                          Edit
                        </Button>
                      </TableCell>
                      <TableCell align="center">
                        <LoadingButton
                          variant="outlined"
                          color="error"
                          onClick={() => {
                            removePaymentType(paymentType.id);
                          }}
                          loading={
                            status?.loading === "delete" && paymentType.id
                          }
                        >
                          Delete
                        </LoadingButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>
      </Grid>
      <PaymentEditDialog
        open={openPaymentTypeUpdate}
        handleClose={handlePaymentTypeClose}
        paymentType={currentItem}
      />
    </Box>
  );
};

export default PaymentList;
